import { createContext } from "react"
import { ResponseStatus, Stage } from "../../api/dtos";

export interface IStageContext {
    data?: Stage;
    code?: string;
    error?: ResponseStatus;
    loading: boolean;
    validating: boolean;
    refresh: () => Promise<Stage | undefined>
}

export const StageContext = createContext<IStageContext>({
    loading: false,
    validating: false,
    data: undefined,
    error: undefined,
    refresh: () => {
        return new Promise<Stage | undefined>(res => {
            res(undefined);
        });
    }
});

export default StageContext;